import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import ConsumptionSourceList from './ConsumptionSourceList';

//redux

const ConsumptionSource = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Operaciones', icon: 'icon-wrench' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Fuentes de Consumo' links={breadcrumbLinks} icon={'icon-car-front'} />
					<ConsumptionSourceList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default ConsumptionSource;
